import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../shared/Header";
import { api } from "../../services/api";

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true); // mostramos mensaje “si existe…”
    } catch (e) {
      // igual mostramos éxito para no filtrar existencia
      setDone(true);
    } finally {
      setSending(false);
    }
  };

  const backgroundURL = `/fondo.png`;

  return (
    <div
      className="min-h-screen bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url('${backgroundURL}')` }}
    >
      <Header
        title="Fichajes"
        subtitle="Recuperación de contraseña"
        showBack
        onBack={() => navigate(-1)}
      />

      <main className="max-w-xl mx-auto px-4 py-8">
        <div className="bg-white/85 backdrop-blur rounded-2xl shadow-xl p-6 sm:p-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            ¿Olvidaste tu contraseña?
          </h2>

          {done ? (
            <p className="text-green-700">
              Si el correo existe, se han enviado instrucciones de restablecimiento.
            </p>
          ) : (
            <form onSubmit={onSubmit} className="space-y-4">
              <label className="block">
                <span className="text-sm text-gray-700">Email</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-1 w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="tucorreo@empresa.com"
                />
              </label>

              <button
                type="submit"
                disabled={sending}
                className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md disabled:opacity-60"
              >
                {sending ? "Enviando…" : "Enviar enlace"}
              </button>
            </form>
          )}

          <div className="mt-6">
            <Link to="/login" className="text-blue-700 hover:underline">
              Volver a iniciar sesión
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

